import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers';
import * as fromUserState from '../reducers/user-state.reducer';

export const getUserState = createFeatureSelector<State, fromUserState.State>('userStates');

export const getStates = createSelector(getUserState, (state) => state.list);
